import styled from 'styled-components';
import colors from '../../assets/colors';

export const Menu = styled.div`
  display: flex;
  margin-bottom: 40px;

  .container {
    min-height: 100px;
    padding: 20px;
    background-color: ${colors.white};
    -webkit-box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
    -moz-box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
    box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
    border-radius: 8px;
    border: 2px solid ${colors.white};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    
    h2 {
      font-size: 1.5rem;
      color: ${colors.primary};
      font-weight: 700;
      text-align: center;
      padding-bottom: 8px;
    }

    p {
      text-align: center;
      font-size: 0.9rem;
      color: #BBBBBB;
      font-weight: 300;
    }

    :hover { border: 2px solid ${colors.primary} }
  }

  .react-tabs__tab--selected { border: 2px solid ${colors.primary} }

  @media screen and (min-width: 769px) {
    .container {
      max-width: 320px;

      :first-child { margin-right: 20px }
    }
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;

    .container {
      flex: 1;

      :first-child { margin-bottom: 20px; }
    }
  }
`;

export const Content = styled.div`
  h2.category {
    font-size: 16px;
    margin: 30px 0 20px;

    :first-child { margin: 20px 0; }
  }
`;
